import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { ResponsiveValue } from 'styled-system';
import { fontSize, lineHeight, themeGet } from 'styled-system';

import { linkStyles } from '../Link';
import { Text } from '../Text';

export const font =
  (size: ResponsiveValue<string | number>, height: ResponsiveValue<string | number>) => props => [
    fontSize({ ...props, fontSize: size }),
    lineHeight({ ...props, lineHeight: height }),
  ];

// Typography for the elements within RichText
// Details: https://www.figma.com/design/ydvKoKzS1GHVkQwFZ2uvKt/New-Typo_Components?node-id=396-45&t=XI0wz5XoLZ4q7I5c-0
// @typography-definition
const UnstyledRichTextBlock = styled(Text)<any>`
  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  & > :not(:first-of-type):not(br) {
    margin-top: ${themeGet('space.sp_16')}px;
  }
  & > :not(:last-child):not(br) {
    margin-bottom: ${themeGet('space.sp_16')}px;
  }

  & a {
    ${linkStyles};
  }

  p,
  pre {
    ${font(['fs_16', null, null, 'fs_18'], ['lh_24', null, null, 'lh_28'])};

    & > span.subheading {
      ${font(['fs_16', null, null, 'fs_18'], ['lh_20', null, null, 'lh_22'])};
    }
  }

  pre {
    white-space: pre-wrap;
  }

  & ul,
  & li {
    padding-left: ${themeGet('space.sp_16')}px;
  }

  ul,
  ol,
  li {
    ${font(['fs_16', null, null, 'fs_18'], ['lh_24', null, null, 'lh_28'])};
  }

  h1 {
    ${font(['fs_22', 'fs_24', 'fs_28', 'fs_32'], ['lh_28', null, 'lh_32', 'lh_36'])};
  }

  h2 {
    ${font(['fs_20', 'fs_22', 'fs_24', 'fs_28'], ['lh_24', 'lh_28', null, 'lh_32'])};
  }

  h3 {
    ${font(['fs_18', 'fs_20', 'fs_22', 'fs_24'], ['lh_22', 'lh_24', 'lh_28'])};
  }

  h4 {
    ${font(['fs_16', null, null, 'fs_18'], ['lh_20', null, null, 'lh_22'])};
  }
`;

const RichTextBlock = (props: ComponentProps<typeof UnstyledRichTextBlock>) => (
  <UnstyledRichTextBlock styled={true} textDecoration="underline" {...props} />
);

export default RichTextBlock;
